import { render, staticRenderFns } from "./SelectionAccordion.vue?vue&type=template&id=8c4607f0&"
import script from "./SelectionAccordion.vue?vue&type=script&lang=ts&"
export * from "./SelectionAccordion.vue?vue&type=script&lang=ts&"
import style0 from "./SelectionAccordion.vue?vue&type=style&index=0&id=8c4607f0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports